import { FormGroup } from '@angular/forms';

export const updateValidationAllControls = (form: FormGroup) => {
    form.markAllAsTouched();
    Object.values(form.controls).forEach(control => control instanceof FormGroup ? updateValidationAllControls(control) : control.updateValueAndValidity({ emitEvent: false }));
    form.updateValueAndValidity();
}
